"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPayloadFactoryFromJS = exports.FilterPayloadFactory = void 0;
const immutable_1 = require("immutable");
exports.FilterPayloadFactory = (0, immutable_1.Record)({
    flowId: null,
    processId: null,
    projectId: null,
    flowName: null,
    projectName: null,
    createDateBefore: null,
    createDateAfter: null,
    statusId: null,
    projectSecretKey: null,
    flowStarterUserId: null,
    flowStarterName: null,
    flowStarterUserName: null,
    initialFilter: true,
    includeDeletedProcesses: false,
    hasError: false
});
const FilterPayloadFactoryFromJS = function (data) {
    return (0, exports.FilterPayloadFactory)(data);
};
exports.FilterPayloadFactoryFromJS = FilterPayloadFactoryFromJS;
//# sourceMappingURL=IFilter.js.map